import './Chip.css';

/**
 * Chip — a pill chip / choice-chip button (b2b-demo DS). Shadow-DOM-safe and
 * themed entirely via widget/theme CSS variables (with fallbacks).
 *
 * States:
 *  - default (unselected)
 *  - `selected` — a solid fill; the fill/text colours are themeable per-context
 *    via the `--chip-selected-bg` / `--chip-selected-color` custom properties
 *    (default = the widget primary on white).
 *
 * Use for quick filters (non-selectable), or single-select "choice chips" in a
 * radiogroup — in that case pass `role="radio"` + `aria-checked` from the
 * parent; extra props (role/aria/onClick/…) are spread onto the <button>.
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.selected]
 * @param {string} [props.className]
 * @param {'button' | 'submit' | 'reset'} [props.type]
 */
export const Chip = ({ children, selected = false, className = '', type = 'button', ...props }) => (
  <button
    type={type}
    className={`sg-chip${selected ? ' sg-chip--selected' : ''}${className ? ` ${className}` : ''}`}
    {...props}
  >
    {children}
  </button>
);

export default Chip;
